import Immutable from 'immutable';
import { select } from 'redux-saga/effects';
import { createBrandStylesByRelationId, createFlatColorsByRelationId, createFlatFontsByRelationId } from 'containers/Common/selectors';
import * as Models from 'models';
import { createStylesWithDefaultBrandStyle } from './createStylesWithDefaultBrandStyle';

export function* useDefaultBrandStyleOnRelation(
  sectionStyles: Immutable.List<string>,
  relationId: string,
): Generator<unknown, Models.TextRelationStyles> {
  const styles = (yield select(createBrandStylesByRelationId(relationId))) as ReturnTypeSaga<ReturnType<typeof createBrandStylesByRelationId>>;
  const colors = (yield select(createFlatColorsByRelationId(relationId))) as ReturnTypeSaga<ReturnType<typeof createFlatColorsByRelationId>>;
  const fonts = (yield select(createFlatFontsByRelationId(relationId))) as ReturnTypeSaga<ReturnTypeSaga<typeof createFlatFontsByRelationId>>;

  return createStylesWithDefaultBrandStyle(sectionStyles, styles, colors, fonts);
}
